import { Backdrop, Box } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/EditOutlined";
import { useSimpleModalToggle } from "components/dialogs/useSimpleModal";
import React from "react";
import { FormWithRedirect, useMutation, useNotify, useTranslate } from "react-admin";
import { useNotifyError } from "utils/notifiers/useNotifyError";

import { AddEditProductArticleFieldBody } from "./AddEditProductArticleFieldBody";

export const UpdateProductArticle = ({ productArticle }) => {
	const { open, handleOpen, handleClose } = useSimpleModalToggle();
	const notify = useNotify();
	const notifyError = useNotifyError();
	const translate = useTranslate();

	const [approve, { loading }] = useMutation(
		{
			type: "update",
			resource: "product-articles",
			payload: { id: productArticle.id },
		},
		{
			onSuccess: () => {
				handleClose();
				notify(translate("osfc.dialogs.product-articles.update.success"), "success");
			},
			onFailure: (error) => {
				notifyError(error);
			},
		}
	);

	const handleSubmit = (values) => {
		approve({
			payload: {
				id: productArticle.id,
				data: values,
			},
		});
	};

	return (
		<>
			<IconButton aria-label="edit" size="small" color="default" onClick={handleOpen}>
				<EditIcon color="primary" />
			</IconButton>
			{open && (
				<Dialog open={true} onClose={handleClose} maxWidth="md">
					<DialogTitle>
						{translate("resources.product-articles.edit.title")} {productArticle.id}
					</DialogTitle>
					<Box position="relative">
						<FormWithRedirect
							record={productArticle}
							submitOnEnter={false}
							component={DialogContent}
							save={handleSubmit}
							render={({ handleSubmitWithRedirect, form, record }) => (
								<React.Fragment>
									<AddEditProductArticleFieldBody form={form} record={record} />
									<DialogActions>
										<Button disabled={loading} onClick={handleClose} color="primary">
											{translate("ra.action.cancel")}
										</Button>
										<Button disabled={loading} onClick={handleSubmitWithRedirect} color="primary">
											{translate("ra.action.update")}
										</Button>
									</DialogActions>
								</React.Fragment>
							)}
						/>
						<Backdrop
							open={loading}
							style={{
								position: "absolute",
								zIndex: 1000,
								backgroundColor: "rgba(255, 255, 255, 0.7)",
							}}
						>
							<CircularProgress />
						</Backdrop>
					</Box>
				</Dialog>
			)}
		</>
	);
};
